import { trackBooking } from 'store/booking/bookingActions';
import { createPurchaseEvent } from '../eventCreators';
import { createPurchaseEventPayload } from '../dataHelpers/createPurchaseEventPayload';

const emitBookingConfirmationEvent = ({ payload }) => {
  if (!payload?.booking?.reservation) return null;

  const purchaseEvent = createPurchaseEvent(
    createPurchaseEventPayload({
      booking: payload.booking,
      quote: payload.quote,
      isRebooked: payload.isRebooked,
      ctaMessage: payload.ctaMessage,
      ctaMessageCategory: payload.ctaMessageCategory,
    }),
  );

  return purchaseEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [trackBooking]: emitBookingConfirmationEvent };
